import { gql } from '@apollo/client';

export const getOpportunityBubbleChart = gql`
    query getOpportunityBubbleChart(
        $timePeriod: JSONString!
        $filters: JSONString!
        $groupBy: SamyaString!
        $frequency: String!
        $dimension: SamyaString!
    ) {
        getOpportunityBubbleChart(
            timePeriod: $timePeriod
            filters: $filters
            groupBy: $groupBy
            frequency: $frequency
            dimension: $dimension
        ) {
            groupBy
            kpisData {
                kpiName
                kpiValue
            }
        }
    }
`;

export const getOpportunityTrendsChart = gql`
    query getCompetitorsElasticityWeekLvlData(
        $timePeriod: JSONString!
        $attributeType: SamyaString!
        $filters: JSONString!
        $frequency: String!
        $dimension: SamyaString!
    ) {
        getCompetitorsElasticityWeekLvlData(
            timePeriod: $timePeriod
            attributeType: $attributeType
            filters: $filters
            frequency: $frequency
            dimension: $dimension
        ) {
            data {
                attributeName
                startTimestamp
                periodLabel
                bpeCurrent
                bpePrevious
            }
            count
        }
    }
`;

export const getChart2Chart = gql`
    query getAttributeLvlElasticityBreakdown(
        $timePeriod: JSONString!
        $attributeType: SamyaString!
        $filters: JSONString!
        $dimension: SamyaString!
        $limit: Int!
        $frequency: String!
        $offset: Int!
    ) {
        getCompetitorsElasticityBreakdown(
            timePeriod: $timePeriod
            attributeType: $attributeType
            filters: $filters
            dimension: $dimension
            frequency: $frequency
            limit: $limit
            offset: $offset
        ) {
            count
            attributeData {
                attributeName
                competitorAttributeName
                competitorType
                bpe
            }
        }
    }
`;
